let _log = console.log,
	_warn = console.warn,
	_error = console.error;
let errorMessages = {
	TypeError: (error) => {
		_warn(error.toString());
	},
	RangeError: (error) => {
		location.reload();
		return false;
	},
	unknown: (error) => {
		return _warn(error.toString());
	},
};

export default class LogFilter {
	constructor() {
		// this.filterErrors()
		// this.filterWarnings()
	}

	//TODO: Insert code to disable errors on prod
	filterErrors() {
		console.error = function () {
			if (arguments[0].toString().includes(':')) {
				let errorType = arguments[0].toString().split(':')[0],
					action = errorMessages[errorType];

				if (action) {
					action(arguments[0]);
					return true;
				} else {
					return errorMessages['unknown'](arguments[0]);
				}
			} else {
				notification.notify(
					'error',
					'Unknown Error',
					arguments[0].toString(),
				);
				return _warn(arguments[0].toString());
			}
		};
	}

	filterWarnings() {
		console.warn = function () {
			return _log(arguments[0].toString());
		};
	}
}
